import { render, staticRenderFns } from "./PurchaseView.vue?vue&type=template&id=284fa0ca&scoped=true&"
import script from "./PurchaseView.vue?vue&type=script&lang=js&"
export * from "./PurchaseView.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseView.vue?vue&type=style&index=0&id=284fa0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284fa0ca",
  null
  
)

export default component.exports